import { Component, OnInit } from "@angular/core";
import { HomeService } from "../home.service";
import { AuthenticationService } from "@app/_services";

import { NgbCarouselConfig, NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { ActivatedRoute } from "@angular/router";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.less"],
  providers: [NgbCarouselConfig],
})
export class HomeComponent implements OnInit {
  endpointCount: number;
  weFlowCount: number;
  perfCount: number;

  constructor(
    private HomeServices: HomeService,
    private route: ActivatedRoute,
    private auth: AuthenticationService,
    config: NgbCarouselConfig,
    private modalService: NgbModal,
    private titleService: Title,
  ) {
    config.showNavigationArrows = false;
    config.showNavigationIndicators = true;
    config.interval = 5000;
  }

  ngOnInit() {
    this.titleService.setTitle("Relay");

    this.getEndpointCount();
    this.getWebflowCount();
    this.getPerfCount();
    this.checkAuth();
  }

  getEndpointCount() {
    this.HomeServices.getEndpointOnboardCount().subscribe((data) => {
      if (data.code === 200) this.endpointCount = data.response.count.toString().split("");
    });
  }

  getWebflowCount() {
    this.HomeServices.geWebFlowOnboardCount().subscribe((data) => {
      if (data.code === 200) this.weFlowCount = data.response.count.toString().split("");
    });
  }

  getPerfCount() {
    this.HomeServices.getPerfTestCount().subscribe((data) => {
      if (data.code === 200) this.perfCount = data.response.count.toString().split("");
    });
  }

  videoModal(content: any) {
    this.modalService.open(content, {
      size: "lg",
      ariaLabelledBy: "modal-basic-title",
      windowClass: "video-modal",
    });
  }

  /* After login */

  checkAuth() {
    this.route.queryParams.subscribe((params) => {
      if (params.user) {
        this.auth.postLogin(params.user, params.deepLink);
      } else {
        // this.router.navigate(['/']);
      }
    });
  }
}
